export default __webpack_public_path__ + "static/media/32.e7f38b22.svg";